module.exports = __webpack_public_path__ + "assets/img/tab-cover6-203b097b.jpg";